module.exports = __webpack_public_path__ + "img/update_purple.aa8885bd.svg";